export const BUCKET_SIZES = ["day", "week", "month"] as const;
export type BucketSize = (typeof BUCKET_SIZES)[number];

export interface ConsumptionBucket {
  periodStart: string;
  credits: number;
}

export interface ConsumptionReport {
  startingBalance: number;
  currentBalance: number;
  totalConsumed: number;
  buckets: ConsumptionBucket[];
}
